module.exports = __webpack_public_path__ + "img/saveMap.ad34b71b.svg";